import React, { useState, useEffect, useMemo, memo } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Icon, DataTable, Form, Heading6 } from '../../components/widgets';
import { useSelector, useDispatch } from 'react-redux';
import { DISPLAY_DATE_FORMAT2, REGION_TYPE } from '../../constants';
import { saveDistance, getDistanceList, getGeneratedDistanceLists } from "../../actions/distance";
import getCenterOfBounds from 'geolib/es/getCenterOfBounds';
import { getUserId } from '../../helpers/session';
import { Unit } from '../../helpers/unit';
import { toastError, toastSuccess } from '../../actions/toast';
import { Workbook } from 'react-excel-workbook';
import moment from 'moment';
const unit = Unit.getInstance();
const BATCH_SIZE = 100;

const MileageCountModal = props => {
	const { onHide, userIdAccess } = props;
	const dispatch = useDispatch();
	const regionLists = useSelector(state => state.geo.regionsList);
	const distanceLists = useSelector(state => state.distance.distanceList);
	const isRequesting = useSelector(state => state.distance.isRequesting);
	const farmId = useSelector(state => state.geo.farmId);
	const generatedDistanceList = useSelector(state => state.distance.generatedDistanceList);
	const {
		custom: { from, to },
	} = useSelector((state) => state.analyze.searchParams);

	const [regionOffloadHeader, setRegionOffloadHeader] = useState([]);
	const [regionFieldBody, setRegionFieldBody] = useState([]);
	const [fieldDistanceList, setFieldDistanceList] = useState([]);
	const [originalDistanceList, setOriginalDistanceList] = useState([]);
	const [generateDistanceLists, setgenerateDistanceLists] = useState([]);
	const [distanceActive, setDistanceActive] = useState(false);
	const [isGenerated, setIsGenerated] = useState(false);
	const [isNotGenerated, setIsNotGenerated] = useState(false);
	const [isChanged, setIsChanged] = useState(false);
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [isFieldHasData, setFieldHasData] = useState(false);
	const [isSaved, setIsSaved] = useState(false)
	const [matrixRequest, setMatrixRequest] = useState(0);
	const [isRequest, setIsRequest] = useState(false);
	const [TotalRows, setTotalRows] = useState(() => {
		return (regionFieldBody && Array.isArray(regionFieldBody)) ? regionFieldBody.length : 0
	});
	const [visibleRows, setVisibleRows] = useState(20);
	const [isBatchRequests, setIsBatchRequests] = useState(false)
	const [selectedRegions, setSelectedRegions] = useState([])

	const loadMoreRows = () => {
		setVisibleRows(prev => prev + 20);
	};

	const shapesModifedData = (data) => {
		let result = [];
		data.forEach(item => {
			if (item.shapes.length > 0) {
				const shapesArray = item.shapes.map(shape => ({
					geo_region_uuid: item.geo_region_uuid,
					geo_region_name: item.geo_region_name,
					geo_region_type_id: item.geo_region_type_id,
					geo_region_type_description: item.geo_region_type_description,
					geo_shape_uuid: shape.geo_shape_uuid,
					geo_shape_name: shape.geo_shape_name,
					geo_shape_type_id: shape.geo_shape_type_id,
					geo_shape_object_uuid: shape.geo_shape_object_uuid,
					location: getCenterOfBounds(shape.location),
				}));
				result = result.concat(shapesArray);
			}
		});
		return result;
	};

	const getMatrixDistance = (data) => {
		let distance = 0;
		if (generatedDistanceList && generatedDistanceList.length > 0) {
			const matchedItem = generatedDistanceList.find(e =>
				e.source_region_uuid === data.source_region_uuid &&
				e.source_shape_uuid === data.source_shape_uuid &&
				e.destination_region_uuid === data.destination_region_uuid &&
				e.destination_shape_uuid === data.destination_shape_uuid
			);

			if (matchedItem) {
				distance = matchedItem.distance_value;
			}
		}

		return distance;
	};

	useMemo(() => {
		if (farmId) {
			dispatch(getDistanceList(farmId))
		}
	}, [farmId])

	useEffect(() => {
		const OffloadHeader = regionLists.filter((item) => item.geo_region_type_id === REGION_TYPE.OFFLOADSITE);
		let fieldBody = regionLists.filter((item) => item.geo_region_type_id === REGION_TYPE.FIELD || item.geo_region_type_id === REGION_TYPE.TRANSLOADSITE);
		const offloadList = regionLists.filter((item) => item.geo_region_type_id === REGION_TYPE.OFFLOADSITE);
		fieldBody.push(...offloadList);

		const regionOffloadHeader = shapesModifedData(OffloadHeader);
		const regionFieldBody = shapesModifedData(fieldBody)
		setRegionOffloadHeader(regionOffloadHeader);
		setRegionFieldBody(regionFieldBody);
		setTotalRows(regionFieldBody.length)

		const totalLengthObjects = [];
		const formatedObjects = []
		regionFieldBody.forEach((each) => {
			regionOffloadHeader.forEach((item) => {
				const formatedObj = {
					origins: `${each.location.latitude},${each.location.longitude}`,
					destinations: `${item.location.latitude},${item.location.longitude}`,
					source_region_uuid: each.geo_region_uuid,
					source_region_type_id: each.geo_region_type_id,
					source_shape_uuid: each.geo_shape_uuid,
					destination_region_uuid: item.geo_region_uuid,
					destination_shape_uuid: item.geo_shape_uuid,
					destination_region_type_id: item.geo_region_type_id,
				}

				const newObj = {
					source_region_uuid: each.geo_region_uuid,
					source_shape_uuid: each.geo_shape_uuid,
					source_region_type_id: each.geo_region_type_id,
					destination_region_uuid: item.geo_region_uuid,
					destination_shape_uuid: item.geo_shape_uuid,
					destination_region_type_id: item.geo_region_type_id,
					is_generated: false
				};
				formatedObjects.push(formatedObj);
				totalLengthObjects.push(newObj);
			});
		});
		setFieldDistanceList(totalLengthObjects);
		setgenerateDistanceLists(formatedObjects)
	}, [regionLists]);

	useEffect(() => {
		setFieldHasData(fieldDistanceList.length > 0);

		const timer = setTimeout(() => {
			setIsGenerated(false);
		}, 1000);
		return () => clearTimeout(timer);

	}, [fieldDistanceList]);


	useMemo(() => {
		if (distanceActive) {
			const totalLengthObjects = [];
			fieldDistanceList.forEach((each) => {
				const distance = getMatrixDistance(each)
				const distanceInMile = distance;
				const finalData = {
					...each,
					distance_value: distanceInMile ? distanceInMile : each.distance_value ? each.distance_value : distance,
					is_generated: distanceInMile ? true : each.is_generated
				}

				totalLengthObjects.push(finalData)
			});
			setFieldDistanceList(totalLengthObjects);
			setTimeout(() => {
				setIsSaved(true)
			}, 1000)
		}
	}, [distanceActive, generatedDistanceList])

	useEffect(() => {
		setIsRequest(true);
		const distanceData = ((distanceLists && distanceLists.length > 0) ? distanceLists : fieldDistanceList).map(item => ({
			source_region_uuid: item.source_region_uuid,
			source_shape_uuid: item.source_shape_uuid,
			source_region_type_id: item.source_region_type_id,
			destination_region_uuid: item.destination_region_uuid,
			destination_shape_uuid: item.destination_shape_uuid,
			destination_region_type_id: item.destination_region_type_id,
			distance_value: item.distance_value,
			isFilled: true,
			is_edited: Boolean(item.is_edited),
			is_generated: Boolean(item.is_generated)
		}));

		const updatedDistanceData = fieldDistanceList.map(item => {
			const matchingItem = distanceData.find(newItem =>
				newItem.source_region_uuid === item.source_region_uuid &&
				newItem.source_shape_uuid === item.source_shape_uuid &&
				newItem.destination_region_uuid === item.destination_region_uuid &&
				newItem.destination_shape_uuid === item.destination_shape_uuid
			);

			return matchingItem
				? { ...item, ...matchingItem, distance_value: unit.toFixedOf(matchingItem.distance_value, 2) }
				: { ...item, distance_value: unit.toFixedOf(item.distance_value, 2) };
		});

		if (updatedDistanceData.length) {
			setFieldDistanceList(updatedDistanceData);
			setOriginalDistanceList(updatedDistanceData);
			setIsNotGenerated(updatedDistanceData.some(item => !item.is_generated));
		}

		setIsGenerated(false);
		setIsChanged(false);

		const timer = setTimeout(() => setIsRequest(false), 1000);
		return () => clearTimeout(timer);

	}, [distanceLists, isFieldHasData]);

	const filteredRows = useMemo(() => {
		if (!selectedRegions || selectedRegions.length === 0) return regionFieldBody;
		return regionFieldBody.filter((row) =>
			(selectedRegions || []).some((region) => region.value === row.geo_region_uuid)
		);
	}, [regionFieldBody, selectedRegions]);

	const displayedRows = useMemo(() => { return filteredRows.slice(0, visibleRows) }, [filteredRows, visibleRows]);

	const handleInputChange = (value, rowIndexKey, columnIndexKey) => {
		setIsChanged(true);
		const newDistanceValue = value === "" ? 0 : parseFloat(value);

		setFieldDistanceList(prevData =>
			prevData.map(item => {
				if (item.source_region_uuid !== rowIndexKey || item.destination_region_uuid !== columnIndexKey) {
					return item;
				}

				const foundItem = distanceLists && distanceLists.length > 0 && distanceLists.find(
					saved => saved.source_region_uuid === rowIndexKey && saved.destination_region_uuid === columnIndexKey
				);

				const savedValue = foundItem && foundItem.distance_value;
				const isEdited = savedValue !== undefined
					? savedValue !== newDistanceValue && item.isFilled
					: item.distance_value !== newDistanceValue;

				return item.distance_value === newDistanceValue && item.is_edited === isEdited
					? item
					: { ...item, distance_value: newDistanceValue, is_edited: isEdited };
			})
		);
	};

	useEffect(() => {
		if (!isSaved) return;

		setDistanceActive(false);
		const timer = setTimeout(() => {
			setIsSaved(false);
			dispatch(getDistanceList(farmId));
		}, 1000);

		return () => clearTimeout(timer);
	}, [isSaved]);


	const generateDistance = () => {
		setIsGenerated(true)
		setDistanceActive(true)
		setIsChanged(true)
		let nonGeneratedLists = []
		let nonSavedDistanceLists = fieldDistanceList && fieldDistanceList.length > 0 ? fieldDistanceList : [];
		nonSavedDistanceLists = nonSavedDistanceLists.filter((data) => !data.is_generated)
		if (generateDistanceLists && generateDistanceLists.length > 0) {

			nonGeneratedLists = generateDistanceLists.filter(e => {
				return nonSavedDistanceLists.some(newItem =>
					!newItem.is_generated &&
					newItem.source_region_uuid === e.source_region_uuid &&
					newItem.source_shape_uuid === e.source_shape_uuid &&
					newItem.destination_region_uuid === e.destination_region_uuid &&
					newItem.destination_shape_uuid === e.destination_shape_uuid
				);
			});

			if (selectedRegions && selectedRegions.length > 0) {
				nonGeneratedLists = nonGeneratedLists.filter((row) =>
					(selectedRegions || []).some((region) => region.value === row.source_region_uuid)
				)
			}

			if (nonGeneratedLists.length === 0) {
				return;
			}

			const batches = [];

			nonGeneratedLists = nonGeneratedLists.filter((item) => item.source_region_uuid !== item.destination_region_uuid);

			for (let i = 0; i < nonGeneratedLists.length; i += BATCH_SIZE) {
				batches.push(nonGeneratedLists.slice(i, i + BATCH_SIZE));
			}

			const processBatch = (index) => {
				if (index >= batches.length) {
					dispatch(toastSuccess("All distance processed successfully!"));
					setIsBatchRequests(false)
					return;
				}

				setIsBatchRequests(true)
				const params = {
					farmId,
					distance: batches[index]
				};

				Promise.resolve(dispatch(getGeneratedDistanceLists(params)))
					.then(() => processBatch(index + 1))
					.catch((error) => dispatch(toastError("Error processing batch:", error)));
			};

			processBatch(0);

			// const params = {
			// 	farmId: farmId,
			// 	distance: nonGeneratedLists
			// }

			// dispatch(getGeneratedDistanceLists(params))
		}
	}

	const openModal = () => {
		let nonSavedDistanceLists = fieldDistanceList && fieldDistanceList.length > 0 ? fieldDistanceList : [];
		nonSavedDistanceLists = nonSavedDistanceLists.filter((data) => !data.is_generated)

		if (generateDistanceLists && generateDistanceLists.length === 0) {
			setMatrixRequest(0);
			setShowConfirmModal(true);
			return;
		}

		let nonGeneratedLists = generateDistanceLists.filter(e => {
			return nonSavedDistanceLists.some(newItem =>
				!newItem.is_generated &&
				newItem.source_region_uuid === e.source_region_uuid &&
				newItem.source_shape_uuid === e.source_shape_uuid &&
				newItem.destination_region_uuid === e.destination_region_uuid &&
				newItem.destination_shape_uuid === e.destination_shape_uuid
			);
		});


		if (selectedRegions && selectedRegions.length > 0) {
			nonGeneratedLists = nonGeneratedLists && nonGeneratedLists.length > 0 && nonGeneratedLists.filter((row) => selectedRegions.some((e) => e.value === row.source_region_uuid))
		}

		const matrixLength = nonGeneratedLists.length;
		setMatrixRequest(matrixLength)
		setShowConfirmModal(true);
	}

	const modalClose = () => {
		setIsGenerated(false)
		setDistanceActive(false)
		setIsChanged(false)
		return onHide()
	}

	const handleMileageSave = () => {
		setDistanceActive(false)
		let filteredInputs = fieldDistanceList.filter(item => (item.distance_value > 0));
		filteredInputs = filteredInputs.filter((currentItem) => {
			const originalItem = originalDistanceList.find(
				(original) =>
					original.source_region_uuid === currentItem.source_region_uuid &&
					original.destination_region_uuid === currentItem.destination_region_uuid
			);

			if (!originalItem) return true;

			return originalItem.distance_value !== currentItem.distance_value;
		});

		const FinalDistanceData = filteredInputs.map((data) => {
			const { isFilled, is_edited, is_generated, ...rest } = data;
			const isEditedNumber = is_edited ? 1 : 0;

			const isGeneratedNumber = is_generated ? 1 : 0;

			return {
				...rest,
				is_edited: isEditedNumber,
				is_generated: isGeneratedNumber,
				distance_value: Number(data.distance_value)
			};
		})

		const batches = [];

		for (let i = 0; i < FinalDistanceData.length; i += BATCH_SIZE) {
			batches.push(FinalDistanceData.slice(i, i + BATCH_SIZE));
		}

		const processBatch = (index) => {
			if (index >= batches.length) {
				dispatch(toastSuccess("All Distances saved successfully!"));
				setIsChanged(false);
				setTimeout(() => {
					dispatch(getDistanceList(farmId))
					setIsBatchRequests(false);
				}, 1000);
				return;
			}
			setIsBatchRequests(true);

			const params = {
				farm_uuid: farmId,
				distance_datas: batches[index],
				created_by: getUserId(),
			};

			dispatch(saveDistance(params));
			setTimeout(() => processBatch(index + 1), 500);
		};

		processBatch(0);

		// const params = {
		// 	farm_uuid: farmId,
		// 	distance_datas: [...FinalDistanceData],
		// 	created_by: getUserId()
		// }

		// dispatch(saveDistance(params))
		// setIsChanged(false)
		// setTimeout(() => { dispatch(getDistanceList(farmId)) }, 1000)
	}

	const fieldDistanceMap = useMemo(() => {
		return (fieldDistanceList && fieldDistanceList.length > 0) && fieldDistanceList.reduce((acc, item) => {
			acc[`${item.source_region_uuid}_${item.destination_region_uuid}`] = item;
			return acc;
		}, {});
	}, [fieldDistanceList]);

	const getDistanceData = (rowIndexKey, columnIndexKey) => {
		const key = `${rowIndexKey}_${columnIndexKey}`;
		const item = (fieldDistanceMap && fieldDistanceMap[key]) || {};
		return {
			rowInputValue: (item && item.distance_value) ? item.distance_value : '',
			isFilledValue: (item && item.isFilled) ? item.isFilled : false,
			isEditedValue: (item && item.is_edited) ? item.is_edited : false,
			isGenerated: (item && item.is_generated) ? item.is_generated : false,
		};
	};

	const options = useMemo(() => {
		if (Array.isArray(regionFieldBody) && regionFieldBody.length > 0) {
			return regionFieldBody.map((e) => ({
				value: e.geo_region_uuid,
				label: e.geo_region_name
			}));
		}
		return [{ value: null, label: '' }];
	}, [regionFieldBody]);

	const addStretchTableHeader = () => {
		const header = regionOffloadHeader.map((item) => ({
			key: item.geo_shape_name,
			label: item.geo_shape_name,
		}));
		header.unshift({ key: 'geo_shape_name', label: '*' });
		return header.map((item, index) => (
			<Workbook.Column key={index} value={item.key} label={item.label} />
		));
	};

	const getWorkSheets = () => {
		const preparedSheetData = displayedRows.map((rowItem) => {
			const rowIndexKey = rowItem.geo_region_uuid;
			const rowData = {
				geo_shape_name: rowItem.geo_shape_name,
			};

			regionOffloadHeader.forEach((columnItem) => {
				const columnIndexKey = columnItem.geo_region_uuid;
				const { rowInputValue } = getDistanceData(rowIndexKey, columnIndexKey);
				rowData[columnItem.geo_shape_name] = rowInputValue || 0;
			});

			return rowData;
		}
		);

		return (
			<Workbook.Sheet data={preparedSheetData} name="Stretch table">
				{addStretchTableHeader()}
			</Workbook.Sheet>
		);
	};
	const getExcelFileName = () => {

		let dateRange = `${moment.utc(from).format(DISPLAY_DATE_FORMAT2)}`;

		if (
			moment.utc(from).format(DISPLAY_DATE_FORMAT2) ===
			moment.utc(to).format(DISPLAY_DATE_FORMAT2)
		)
			dateRange = `${moment.utc(from).format(DISPLAY_DATE_FORMAT2)}`;
		else
			dateRange = `${moment
				.utc(from)
				.format(DISPLAY_DATE_FORMAT2)} to ${moment
					.utc(to)
					.format(DISPLAY_DATE_FORMAT2)}`;

		return `stretch_table${dateRange ? `_${dateRange}` : ""
			}.xlsx`;
	};

	const fileName = getExcelFileName();
	return (
		<Modal show={true} onHide={modalClose} className="modal-form stretch_table_modal" size="xl">
			<Form className="eg-form load-modal">
				<Modal.Header closeButton>
					<Modal.Title className="d-flex w-100 mb-2 justify-content-between">
						<div>
							<Heading6>
								Stretch table <span>(Miles)</span>
							</Heading6>

							<Form.Group className="select-input stretch_search mb-0">
								<Form.Select
									options={options}
									isMulti
									placeholder="Search & Select..."
									value={selectedRegions}
									onChange={setSelectedRegions}
									className="multi-select-component multi_tick_checkbox"
									classNamePrefix="multibox"
								>
								</Form.Select>
							</Form.Group>
						</div>
						<div className='d-flex align-items-center'>
							{userIdAccess && !(isRequesting && isRequest) && (
								<button
									type="button"
									className={`genarate_distance auto-generate-btn ${(!isNotGenerated || isBatchRequests) ? 'd-none' : ''} ml-3`}
									onClick={openModal}
								>
									<h6>Auto Generate</h6>
									<i className="fa fa-magic" aria-hidden="true"></i>
								</button>
							)}
							<Workbook
								filename={fileName}
								element={
									<Button size="sm" className="ml-2 mr-3 w-100">
										<i className="fa fa-cloud-download mr-2" />
										Download
									</Button>
								}
							>
								{getWorkSheets("all")}
							</Workbook>
							{/* <Dropdown className="loadHistory_download">
								<Dropdown.Toggle variant="primary" id="dropdown-basic">
									<i className="fa fa-cloud-download" /> Download
								</Dropdown.Toggle>
								<Dropdown.Menu disabled={false}>
									<Dropdown.Item
										href="#"
										className="p-0"
										disabled={false}
									>
										<Workbook
											filename={"mileage_count.xlsx"}
											element={
												<Button size="sm" className="mr-2 w-100">
													All
												</Button>
											}
										>
											{getWorkSheets("all")}
										</Workbook>
									</Dropdown.Item>
									<Dropdown.Item href="#" className="p-0">
										<Workbook
											filename={"mileage_count_selected.xlsx"}
											element={
												<Button
													size="sm"
													disabled={false}
													className="mr-2 w-100"
												>
													Selected
												</Button>
											}
										>
											{getWorkSheets("visible")}
										</Workbook>
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown> */}

						</div>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className={`py-0 ${(isRequesting || isBatchRequests) ? 'disabled' : ''}`}>
					{(isRequesting || isRequest) ? (
						<DataTable.Loading className="h-100" />
					) : (
						<>
							<DataTable className={`mileage_container_table ${isGenerated ? 'is_generating' : ''}`}>
								<DataTable.Header className="mileage_container_table_header">
									<DataTable.Row>
										<DataTable.Cell style={{ minWidth: '140px', width: '240px' }}>*</DataTable.Cell>
										{regionOffloadHeader.map((item, index) => (
											<DataTable.Cell style={{ minWidth: "100px", width: 'auto' }} key={index}>{item.geo_shape_name}</DataTable.Cell>
										))}
									</DataTable.Row>
								</DataTable.Header>
								<DataTable.Body>
									{displayedRows.map((rowItem, rowIndex) => {
										const rowIndexKey = rowItem.geo_region_uuid;
										return (
											<DataTable.Row key={`header_${rowIndex}`}>
												<DataTable.Cell style={{ minWidth: '140px', width: 'max-content' }}>
													{rowItem.geo_shape_name}
												</DataTable.Cell>
												{regionOffloadHeader.map((columnItem, columnIndex) => {
													const columnIndexKey = columnItem.geo_region_uuid;
													const { rowInputValue, isFilledValue, isEditedValue, isGenerated } =
														getDistanceData(rowIndexKey, columnIndexKey);

													return (
														<DataTable.Cell key={`body_${columnIndex}`}>
															{/* {userIdAccess ?  */}
															<div className="mileage_input_container">
																<input
																	className={`mileage_inputs ${isFilledValue && !isGenerated && !isEditedValue
																		? 'is_filled'
																		: isEditedValue
																			? 'is_edited'
																			: isGenerated
																				? 'is_generated'
																				: ''
																		}`}
																	type="number"
																	placeholder="0"
																	min="0"
																	max="100000"
																	step="0.01"
																	disabled={rowItem.key === 'total'}
																	value={rowInputValue || ''}
																	onChange={(e) =>
																		handleInputChange(e.target.value, rowIndexKey, columnIndexKey, 'number')
																	}
																/>
															</div>
															{/* :	<div className={`mileage_inputs ${isFilledValue && !isGenerated && !isEditedValue
																	? 'is_filled'
																	: isEditedValue
																		? 'is_edited'
																		: isGenerated
																			? 'is_generated'
																			: ''
																	}`}>
																	{rowInputValue ? rowInputValue : 0}
																</div>
															} */}
														</DataTable.Cell>
													);
												})}
											</DataTable.Row>
										);
									})}
								</DataTable.Body>
							</DataTable>

							<div className="load-more text-center my-3">
								{(visibleRows < regionFieldBody.length && (visibleRows > selectedRegions)) && (
									<Button variant="outline-primary" size="sm" onClick={() => loadMoreRows()}>
										Load More...
									</Button>
								)}
							</div>
						</>
					)}
				</Modal.Body>
				{<Modal.Footer className='stretch_table_footer'>
					{(!isRequesting || !isRequest) && <div className={`d-flex total_rows_list ${userIdAccess ? 'total_rows_list' : 'total_rows_list_relative'}`}>
						Total Rows {`${(visibleRows >= TotalRows) ? TotalRows : visibleRows} / ${TotalRows}`}
					</div>}
					{/* {userIdAccess && <> */}
					<Button size="sm" variant="danger" onClick={onHide}>
						<Icon className="fa fa-ban" /> Close
					</Button>

					<Button size="sm" className={`${!isChanged ? 'disabled' : ''}`} variant="primary" onClick={handleMileageSave}>
						<Icon className="fa fa-floppy-o" /> {distanceLists && distanceLists.length > 0 ? 'Update' : 'Save'}
					</Button>
					{/* </>} */}
				</Modal.Footer>}
			</Form>

			<Modal.Confirm
				isOpen={showConfirmModal}
				onConfirm={generateDistance}
				iconClassName="fa fa-magic"
				className="stretch_modal_confirm shadow"
				body={
					<div
						dangerouslySetInnerHTML={{
							__html: `Distance is calculated using third-party APIs and involves a <span class='text-danger'>high cost (1000 calls take $10 USD).</span> Are you sure you want to go ahead and <span class='text-danger'>make the ${matrixRequest} calls</span> now?`,
						}}
					/>
				}
				onHide={() => setShowConfirmModal(false)}
			/>
		</Modal>
	);
};

export default memo(MileageCountModal);